import { initFederation } from '@angular-architects/native-federation';

void initFederation({ 'arena-admin': './remoteEntry.json' })
  .then(() => import('./bootstrap'))
  .catch((error: unknown) => console.error('Não foi possível iniciar a federação do Arena.', error));
